/* Copyright (c) Trimble Inc. All rights reserved. */
import React, { useEffect } from "react";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import { ProductServices } from "../components/ProductServices";
import GenericPageTitle from "modus/components/generic-page-title/GenericPageTitle";
import { Box, Grid, Paper } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { ConsumerProductService } from "pages/home/consumer/service/ConsumerProductService";
import { useParams } from "react-router";

export const ProductSummary: React.FC = () => {

  const {productId} = useParams<any>();
  const [response, {subscribe}] = useAsyncAction(() => ConsumerProductService.getProduct(productId));

  useEffect(() => {
    setTimeout(subscribe, 3000);
  }, [subscribe]);

  return (
    <Box m={1}>
      {response.loaded && response?.value?.data && (
        <>
          <GenericPageTitle
            title={<>{response?.value?.data?.displayName ?? response.value?.data?.name}</>}
            description={
              <>
                Subscribe to products to begin leveraging API and Event
                capabilities
              </>
            }
            noControls
            noSubTitle
          />
          {response.value?.data?.services && (
            <ProductServices services={response.value?.data?.services} />
          )}
        </>
      )}
      {!response.loaded && (
        <>
          <GenericPageTitle noControls noSubTitle/>
          <Grid container>
            <Grid item md={6} xs={12}>
              <Box py={2}>
                <Skeleton
                  animation="wave"
                  variant="rect"
                  height={"56px"}
                  width="100%"
                />
              </Box>
            </Grid>
          </Grid>
          <Paper style={{ marginTop: "30px" }}>
            <Box p={2} style={{ width: "100%" }}>
              <Skeleton
                animation="wave"
                variant="rect"
                height={"200px"}
                width="100%"
              />
            </Box>
          </Paper>
        </>
      )}
    </Box>
  );
};

export default ProductSummary;
